import request from '@/utils/requestUtil'

// 获取当前商品相关优惠券
export function fetchProductCouponList(productId) {
  return request({
    method: 'GET',
    url: `/member/coupon/listByProduct/${productId}`
  })
}

// 领取指定优惠券
export function addMemberCoupon(couponId) {
  return request({
    method: 'POST',
    url: `/member/coupon/add/${couponId}`
  })
}

// 获取用户优惠券列表
export function fetchMemberCouponList(params) {
  return request({
    method: 'GET',
    url: '/member/coupon/list',
    params
  })
}

// 获取登录会员购物车的相关优惠券
export function listCartCoupon(type) {
  return request({
    method: 'GET',
    url: `/member/coupon/list/cart/${type}`
  })
}

// 获取用户优惠券历史列表
export function listHistoryCoupon(params) {
  return request({
    method: 'GET',
    url: `/member/coupon/listHistory`,
    params
  })
}
